<!-- Merchant Receipt Modal -->
<ng-template #merchantReceipt let-modal>
  <div class="modal-header pb-0">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="this.closeModal(modal)"
    ></button>
  </div>
  <div class="modal-body px-4 py-3">
    <div id="merchantReceipt" class="email-body">
      <div class="header">
        <span class="transaction-status">Authorized</span>
        <div class="d-flex gap-4">
          <a
            role="button"
            class="print-icon"
            id="printReceipt-shopper"
            ad-tooltip
            data-body="Print receipt"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-printer-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"
              />
              <path
                d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
              />
            </svg>
          </a>
          <a
            role="button"
            class="email-icon"
            id="emailReceipt-shopper"
            ad-tooltip
            data-body="Email receipt"
            data-bs-toggle="modal"
            data-bs-target="#email-send"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-envelope-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"
              />
            </svg>
          </a>
        </div>
      </div>
      <div class="subheader">
        <span id="insured-name">Chris Loewenberg</span>
        <span id="transaction-amount" style="float: right">$12,000.00</span>
      </div>
      <div class="content" style="padding: 1rem 1.5rem; max-width: 800px">
        <span
          class="subtitle"
          style="
            margin-top: 0;
            color: black;
            font-weight: 200;
            font-size: 18px;
            line-height: 1.25;
            margin: 0.5rem 0;
            letter-spacing: 1px;
            display: block;
          "
          >Shopper Details</span
        >
        <table class="content-rows" style="margin-bottom: 0.5rem; width: 100%; border-spacing: 0px">
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="shopper-address"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Address
            </td>
            <td id="shopper-address" style="width: 50%">Shopper Address</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="shopper-email"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Email
            </td>
            <td id="shopper-email" style="width: 50%">Shopper Email</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="shopper-phone"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Phone
            </td>
            <td id="shopper-phone" style="width: 50%">Shopper Phone</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="shopper-company-name"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Company Name
            </td>
            <td id="shopper-company-name" style="width: 50%">--</td>
          </tr>
        </table>
        <span
          class="subtitle"
          style="
            color: black;
            font-weight: 200;
            font-size: 18px;
            line-height: 1.25;
            margin: 0.5rem 0;
            letter-spacing: 1px;
            display: block;
          "
          >Merchant Details</span
        >
        <table class="content-rows" style="margin-bottom: 0.5rem; width: 100%; border-spacing: 0px">
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="merchant-name"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Merchant Name
            </td>
            <td id="merchant-name" style="width: 50%">FMK Agency</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="merchant-dba"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Merchant DBA
            </td>
            <td id="merchant-dba" style="width: 50%">FMK Agency SFO-007</td>
          </tr>
        </table>
        <span
          class="subtitle"
          style="
            color: black;
            font-weight: 200;
            font-size: 18px;
            line-height: 1.25;
            margin: 0.5rem 0;
            letter-spacing: 1px;
            display: block;
          "
          >Payment Details</span
        >
        <table class="content-rows" style="margin-bottom: 0.5rem; width: 100%; border-spacing: 0px">
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="transaction-invoice"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Reference value
            </td>
            <td id="transaction-invoice" style="width: 50%">InvoiceNumber-005</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="transaction-id"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Transaction ID
            </td>
            <td id="transaction-id" style="width: 50%">TransactionID-01</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="transaction-ref"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Merchant Reference
            </td>
            <td id="transaction-ref" style="width: 50%">MerchantRef-01</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="transaction-trace"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Trace number
            </td>
            <td id="transaction-trace" style="width: 50%">TraceNumber-01</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="shopper-name"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Account Holder Name
            </td>
            <td id="shopper-name" style="width: 50%">Chris Loewenberg</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="transaction-date"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Date and Time
            </td>
            <td id="transaction-date" style="width: 50%">08-23-2022 13:06:05(ET)</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="transaction-status"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Status
            </td>
            <td id="transaction-status" style="width: 50%">Failed</td>
          </tr>
          <tr class="info-row" style="width: 100%">
            <td
              class="label"
              for="transaction-details"
              style="width: 50%; font-weight: 700; text-transform: uppercase"
            >
              Account Details
            </td>
            <td id="transaction-details" style="width: 50%">****0007 (ACH)</td>
          </tr>
        </table>
        <div class="total-box">
          <table style="width: 100%; border-spacing: 0px">
            <tr class="total-row" style="width: 100%">
              <td
                class="label"
                for="transaction-subtotal"
                style="width: 50%; font-weight: 700; text-transform: uppercase"
              >
                subtotal
              </td>
              <td id="transaction-subtotal" style="width: 50%">$12,000.00</td>
            </tr>
            <tr class="total-row" style="width: 100%">
              <td
                class="label"
                for="transaction-fees"
                style="width: 50%; font-weight: 700; text-transform: uppercase"
              >
                Technology Fees
              </td>
              <td id="transaction-fees" style="width: 50%">$5.00</td>
            </tr>
          </table>
          <div class="line" style="border-bottom: 1px solid black; margin: 0.5rem 0"></div>
          <table style="width: 100%; border-spacing: 0px">
            <tr class="total-row" style="width: 100%">
              <td
                class="label"
                for="transaction-total"
                style="width: 50%; font-weight: 700; text-transform: uppercase"
              >
                Total
              </td>
              <td id="transaction-total" style="width: 50%">$12,005.00</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="header">
  <div class="d-flex justify-content-between align-items-center">
    <h3>{{ 'paymentDetails.header' | translate }}</h3>

    <div ngbDropdown class="dropdown">
      <div id="actionsButton" class="button button-green" ngbDropdownToggle>
        {{ 'paymentDetails.actions' | translate }}
        <span class="material-symbols-outlined">&#xe313;</span>
      </div>
      <ul class="dropdown-menu bg-white border-0 shadow" ngbDropdownMenu>
        <li
          [class.disabled]="!isRefundEligible"
          ngbDropdownItem
          id="refundAction"
          (click)="isRefundEligible && openRefundModal('new', refundModal1)"
          tabindex="0"
          (keydown.enter)="isRefundEligible && openRefundModal('new', refundModal1)"
        >
          {{ 'paymentDetails.refundPayment' | translate }}
          @if (!isRefundEligible) {
            <ng-container>
              <ng-template #tipContent>
                <span [innerHTML]="'paymentDetails.refundNotAvailable' | translate"></span>
              </ng-template>
              <i
                class="bi bi-exclamation-circle mx-1 info-icon-only"
                placement="top"
                [ngbTooltip]="tipContent"
                tooltipClass="custom-tooltip"
                (click)="!isRefundEligible && $event.stopPropagation()"
                (mousedown)="!isRefundEligible && $event.stopPropagation()"
              ></i>
            </ng-container>
          }
        </li>
        <!-- <li ngbDropdownItem id="merchantReceiptAction" (click)="this.openModal(merchantReceipt)">{{ "paymentDetails.merchantReceipt" | translate }}</li>
                <li ngbDropdownItem id="shopperReceiptAction">{{ "paymentDetails.shopperReceipt" | translate }}</li> -->
      </ul>
    </div>
  </div>
  <a class="back-link" (click)="backToPayments()">
    &lt;&lt;&nbsp;{{ 'common.backTo' | translate }}
    <span id="prev-url-name">{{ 'sideNav.payments' | translate }}</span>
  </a>
</div>
@if (isLoader() || isLoader_checkRefundEligiblity()) {
  <app-loader></app-loader>
}

<ng-template #refundModal1 let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
      {{ 'paymentDetails.refundTransaction.refundTransaction' | translate }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="resetForms(); closeModal(modal)"
    ></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="refundForm">
      <p class="subtext">
        {{ 'paymentDetails.refundTransaction.refundWarning' | translate }}
      </p>
      <div class="input-container my-0">
        @if (transDetails?.tenderInfo?.captureAmount === transDetails?.remainingAmount) {
          <div class="d-flex align-items-center gap-2">
            <input
              type="radio"
              name="refundType"
              formControlName="refundType"
              id="select-net-refund"
              value="net"
              autocomplete="off"
            />
            <label for="select-net-refund" class="my-2">
              {{ 'paymentDetails.refundTransaction.totalRefundOf' | translate }}
              <span id="output-net-refund">
                ${{ transDetails?.tenderInfo?.captureAmount | customFormatCurrency }}
              </span>
              <ng-template #tipContent1>
                {{ 'paymentDetails.refundTransaction.tooltipForTotalRefund' | translate }}
              </ng-template>
              <i
                class="bi bi-exclamation-circle mx-1"
                placement="top"
                [ngbTooltip]="tipContent1"
                tooltipClass="custom-tooltip"
              ></i>
            </label>
          </div>
        }
        @if (transDetails?.tenderInfo?.captureAmount !== transDetails?.remainingAmount) {
          <div class="d-flex align-items-center gap-2">
            <input
              type="radio"
              name="refundType"
              formControlName="refundType"
              id="select-net-refund"
              value="net"
              autocomplete="off"
            />
            <label for="select-net-refund" class="my-2">
              {{ 'paymentDetails.refundTransaction.remainingAmount' | translate }}
              <span id="output-net-refund">
                ${{ transDetails?.remainingAmount | customFormatCurrency }}
              </span>
            </label>
          </div>
        }
        @if (
          transDetails?.transactionStatus === 'Success' &&
          transDetails?.tenderInfo?.captureAmount !== transDetails?.subTotalAmount
        ) {
          <div class="d-flex align-items-center gap-2">
            <input
              type="radio"
              name="refundType"
              formControlName="refundType"
              id="select-subtotal-refund"
              value="subtotal"
              autocomplete="off"
            />
            <label for="select-subtotal-refund" class="my-2">
              {{ 'paymentDetails.refundTransaction.subTotalRefundOf' | translate }}
              <span id="output-subtotal-refund">
                ${{ transDetails?.subTotalAmount | customFormatCurrency }}
              </span>
              <ng-template #tipContent2>
                {{ 'paymentDetails.refundTransaction.tooltipForSubTotalRefund' | translate }}
              </ng-template>
              <i
                class="bi bi-exclamation-circle mx-1"
                placement="top"
                [ngbTooltip]="tipContent2"
                tooltipClass="custom-tooltip"
              ></i>
            </label>
          </div>
        }
        <div class="d-flex w-100 flex-column position-relative">
          <div class="d-flex align-items-center gap-2">
            <input
              type="radio"
              name="refundType"
              formControlName="refundType"
              id="select-partial-refund"
              value="partial"
              autocomplete="off"
            />
            <label for="select-partial-refund" class="my-2">
              {{ 'paymentDetails.refundTransaction.partialRefundOf' | translate }}
              <ng-template #tipContent3>
                {{ 'paymentDetails.refundTransaction.tooltipForPartialRefund' | translate }}
              </ng-template>
              <i
                class="bi bi-exclamation-circle mx-1"
                placement="top"
                [ngbTooltip]="tipContent3"
                tooltipClass="custom-tooltip"
              ></i>
            </label>
          </div>
          <div class="d-flex flex-column" style="margin-left: 1.8rem">
            <input
              class="input-field w-100"
              type="text"
              id="input-refund-amt"
              formControlName="amount"
              (input)="onInput($event)"
              (keypress)="omit_alpha_special_char_include_decimal($event)"
            />
            @if (partialAmountErrorFlag) {
              <span class="subtext">
                {{ 'paymentDetails.refundTransaction.amountExceeding' | translate }}
                ${{ transDetails?.remainingAmount | customFormatCurrency }}</span
              >
            }
            @if (!partialAmountErrorFlag) {
              <span class="subtext">
                {{ 'paymentDetails.refundTransaction.amountNotExceeding' | translate }}
                ${{ transDetails?.remainingAmount | customFormatCurrency }}</span
              >
            }
          </div>
          <span class="error-text">{{ refundFormErrors.amount }}</span>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      #closeAddModal
      class="button button-clear"
      (click)="resetForms(); closeModal(modal)"
    >
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="button button-pink"
      (click)="openConfirmRefundModal(modal, refundModal2)"
    >
      <span>
        @if (isLoader()) {
          <span class="spinner-border spinner-border-sm"></span>
        }
        <span class="m-3">{{ 'paymentDetails.refundTransaction.refund' | translate }}</span>
      </span>
    </button>
  </div>
</ng-template>

<ng-template #refundModal2 let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
      {{ 'paymentDetails.refundTransaction.confirmRefund' | translate }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="resetForms(); closeModal(modal)"
    ></button>
  </div>
  <div class="modal-body">
    <form class="d-flex gap-3 flex-column" [formGroup]="confirmRefundForm">
      <p class="subtext">
        {{ 'paymentDetails.refundTransaction.refundConfirmationMessage' | translate }}
      </p>
      <p class="subtext">
        {{ 'paymentDetails.refundTransaction.refundOf' | translate }}
        @if (refundForm.value.refundType === 'net') {
          <span id="output-net-refund">
            ${{ transDetails?.remainingAmount | customFormatCurrency }}
          </span>
        }
        @if (refundForm.value.refundType === 'subtotal') {
          <span id="output-net-refund">
            ${{ transDetails?.subTotalAmount | customFormatCurrency }}
          </span>
        }
        @if (refundForm.value.refundType === 'partial') {
          <span id="output-net-refund">
            ${{ refundForm.value.amount | customFormatCurrency }}
          </span>
        }
        <br />
        {{ 'paymentDetails.refundTransaction.remainingBalanceOf' | translate }}
        @if (refundForm.value.refundType === 'net') {
          <span id="output-net-balance"> $0.00 </span>
        }
        @if (refundForm.value.refundType === 'subtotal') {
          <span id="output-net-balance">
            ${{
              transDetails?.remainingAmount - transDetails?.subTotalAmount | customFormatCurrency
            }}
          </span>
        }
        @if (refundForm.value.refundType === 'partial') {
          <span id="output-net-refund">
            ${{ transDetails?.remainingAmount - refundForm.value.amount | customFormatCurrency }}
          </span>
        }
      </p>
      <div class="input-container">
        <label for="refundReason">
          <span class="required">*</span>
          {{ 'paymentDetails.refundTransaction.reasonForRefund' | translate }}
        </label>
        <select name="refundReason" id="refundReason" formControlName="reason">
          <option value="" selected disabled>
            {{ 'paymentDetails.refundTransaction.selectAReason' | translate }}
          </option>
          <option value="Fraud">
            {{ 'paymentDetails.refundTransaction.fraud' | translate }}
          </option>
          <option value="Duplicate Purchase">
            {{ 'paymentDetails.refundTransaction.duplicatePurchase' | translate }}
          </option>
          <option value="Product Returned">
            {{ 'paymentDetails.refundTransaction.productReturned' | translate }}
          </option>
          <option value="Shopper Request">
            {{ 'paymentDetails.refundTransaction.shopperRequest' | translate }}
          </option>
          <option value="Other">
            {{ 'paymentDetails.refundTransaction.other' | translate }}
          </option>
        </select>
        <span class="error-text">{{ confirmRefundFormErrors.reason }}</span>
      </div>

      <div class="input-container">
        <label for="refundDetails">
          <span class="required">*</span>
          {{ 'paymentDetails.refundTransaction.additionalDetails' | translate }}
        </label>
        <textarea
          name="refundDetails"
          id="refundDetails"
          cols="30"
          rows="4"
          formControlName="additionalDetails"
        ></textarea>
        <span class="error-text">{{ confirmRefundFormErrors.additionalDetails }}</span>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      #closeAddModal
      class="button button-clear"
      (click)="resetForms(); closeModal(modal)"
    >
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="button button-pink"
      [style]="isLoader_refund() ? 'pointer-events: none; cursor: not-allowed;' : ''"
      (click)="confirmRefundAction(modal)"
    >
      <span>
        @if (isLoader_refund()) {
          <span class="spinner-border spinner-border-sm"></span>
        }
        <span class="m-3">{{ 'paymentDetails.refundTransaction.refund' | translate }}</span>
      </span>
    </button>
  </div>
</ng-template>

<div class="details-container">
  <div class="details-column column-1">
    <div class="details-card">
      <div class="details-header">
        <h5>{{ 'paymentDetails.transactionDetails.header' | translate }}</h5>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.transactionDetails.merchantDba' | translate }}</div>
        <div class="row-value" id="merchantDba">{{ transDetails?.merchantDBAName }}</div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.transactionDetails.companyName' | translate }}</div>
        <div class="row-value" id="companyName">{{ transDetails?.companyName }}</div>
      </div>
      <div class="detail-row">
        <div class="row-key">
          {{ 'paymentDetails.transactionDetails.transactionID' | translate }}
        </div>
        <div class="row-value">
          <span id="transactionID" class="break-line">{{ transDetails?.transactionId }}</span>
          <span
            class="material-symbols-outlined copy-icon"
            (click)="allyCommonService.copyValueToClipboard(transDetails?.transactionId)"
            tabindex="0"
            (keydown.enter)="allyCommonService.copyValueToClipboard(transDetails?.transactionId)"
            >&#xe14d;</span
          >
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">
          {{ 'paymentDetails.transactionDetails.merchantReference' | translate }}
        </div>
        <div class="row-value break-line" id="merchantReference">
          {{ transDetails?.transactionResult?.merchantReference }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.transactionDetails.traceNumber' | translate }}</div>
        <div class="row-value" id="traceNumber">
          {{ transDetails?.transactionResult?.traceNumber }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.transactionDetails.date' | translate }}</div>
        <div class="row-value" id="transactionDate">
          {{ transDetails?.transactionDate | date: 'MMM d,y, h:mm:ss a' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.transactionDetails.currency' | translate }}</div>
        <div class="row-value" id="transactionCurrency">
          {{ 'paymentDetails.transactionDetails.USD' | translate }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.initiatedFrom' | translate }}</div>
        @if (transDetails?.portalName === 'AgentInvATP') {
          <div class="row-value" id="initiatedFrom">
            <img
              src="../../../../assets/images/VertaforeLogo (1).svg"
              alt=""
              aria-hidden="true"
              width="25"
              height="18"
              style="margin-right: 0.2rem"
            />
            {{ transDetails?.portalName }}
          </div>
        }
      </div>
      @if (!isRefundEligible) {
        <div class="detail-row">
          <div class="simple-warning">
            <img src="../../../../assets/images/Warning.svg" alt="warning icon" />
            {{ refundEligibleErrorMsg }}
          </div>
        </div>
      }
    </div>
    <div class="details-card">
      <div class="details-header">
        <h5>{{ 'paymentDetails.shopperDetails.header' | translate }}</h5>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.shopperDetails.fullName' | translate }}</div>
        <div class="row-value" id="shopperName">
          {{ transDetails?.fullName ? transDetails?.fullName : '--' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.shopperDetails.email' | translate }}</div>
        <div class="row-value" id="shopperEmail">
          {{ transDetails?.billingContact?.email ? transDetails?.billingContact?.email : '--' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.shopperDetails.phoneNumber' | translate }}</div>
        <div class="row-value" id="shopperPhone">
          {{ transDetails?.billingContact?.phone ? transDetails?.billingContact?.phone : '--' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">
          {{ 'paymentDetails.shopperDetails.purposeOfPayment' | translate }}
        </div>
        <div class="row-value" id="paymentPurpose">
          {{ transDetails?.paymentDescription ? transDetails?.paymentDescription : '--' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">
          {{ 'paymentDetails.shopperDetails.payingOnBehalfOf' | translate }}
        </div>
        <div class="row-value" id="paymentOnBehalf">
          {{
            transDetails?.shopperCompanyDetails?.shoppercompanyname
              ? transDetails?.shopperCompanyDetails?.shoppercompanyname
              : '--'
          }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.shopperDetails.invoiceNumber' | translate }}</div>
        <div class="row-value" id="invoiceNumber">
          {{ transDetails?.invoiceNo ? transDetails?.invoiceNo : '--' }}
        </div>
      </div>
    </div>
    <div class="details-card">
      <div class="details-header">
        <h5>{{ 'paymentDetails.header' | translate }}</h5>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.method' | translate }}</div>
        <div class="row-value" [ngClass]="transactionMethodClass" id="payment-method">
          @if (transactionMethodClass) {
            <img [src]="'/assets/images/' + transactionMethodClass + '.svg'" alt="" />
          }
          {{ transDetails?.method }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.tokenId' | translate }}</div>
        <div class="row-value" id="token-ID">
          {{ transDetails?.tenderInfo?.accountToken || '--' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.paymentIntent' | translate }}</div>
        <div class="row-value" id="payment-intent">
          {{ transDetails?.paymentIntentId }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.issuerDetails' | translate }}</div>
        <div class="row-value"></div>
      </div>
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.issuerID' | translate }}</div>
        <div class="row-value" id="issuerId">
          {{ transDetails?.tenderInfo?.binNumber ? transDetails?.tenderInfo?.binNumber : '--' }}
        </div>
      </div>
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.issuerName' | translate }}</div>
        <div class="row-value" id="issuerName">
          {{ transDetails?.issuer ? transDetails?.issuer : '--' }}
        </div>
      </div>
      @if (transDetails?.channelType !== 'ACH') {
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.cardDetails' | translate }}</div>
          <div class="row-value"></div>
        </div>
      }
      @if (transDetails?.channelType !== 'ACH') {
        <div class="detail-row indent">
          <div class="row-value">{{ 'paymentDetails.nameOnCard' | translate }}</div>
          <div class="row-value" id="cardName">{{ transDetails?.tenderInfo?.cardHolderName }}</div>
        </div>
      }
      @if (transDetails?.channelType !== 'ACH') {
        <div class="detail-row indent">
          <div class="row-value">{{ 'paymentDetails.cardNumber' | translate }}</div>
          <div class="row-value" id="cardNumber">
            {{ transDetails?.tenderInfo?.maskCardNumber }}
          </div>
        </div>
      }
      @if (transDetails?.channelType === 'ACH') {
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.accountDetails' | translate }}</div>
          <div class="row-value"></div>
        </div>
      }
      @if (transDetails?.channelType === 'ACH') {
        <div class="detail-row indent">
          <div class="row-value">{{ 'paymentDetails.routingNumber' | translate }}</div>
          <div class="row-value" id="cardName">{{ transDetails?.tenderInfo?.routingNumber }}</div>
        </div>
      }
      @if (transDetails?.channelType === 'ACH') {
        <div class="detail-row indent">
          <div class="row-value">{{ 'paymentDetails.accountNumber' | translate }}</div>
          <div class="row-value" id="cardNumber">{{ transDetails?.tenderInfo?.maskAccount }}</div>
        </div>
      }
      @if (transDetails?.channelType === 'ACH') {
        <div class="detail-row indent">
          <div class="row-value">{{ 'paymentDetails.bankName' | translate }}</div>
          <div class="row-value" id="cardNumber">
            {{ transDetails?.tenderInfo?.bankName ? transDetails?.tenderInfo?.bankName : '--' }}
          </div>
        </div>
      }
      @if (transDetails?.channelType === 'ACH') {
        <div class="detail-row indent">
          <div class="row-value">{{ 'paymentDetails.accountHolderName' | translate }}</div>
          <div class="row-value" id="cardNumber">
            {{ transDetails?.tenderInfo?.accountHolderName }}
          </div>
        </div>
      }
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.streetAddress' | translate }}</div>
        <div class="row-value" id="cardStreet">
          {{ transDetails?.billingContact?.address?.addressLine2 || '--' }}
        </div>
      </div>
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.unit' | translate }}</div>
        <div class="row-value" id="cardUnit">
          {{ transDetails?.billingContact?.address?.addressLine1 || '--' }}
        </div>
      </div>
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.country' | translate }}</div>
        <div class="row-value" id="cardCountry">{{ transDetails?.countryName || '--' }}</div>
      </div>
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.city' | translate }}</div>
        <div class="row-value" id="cardCity">
          {{ transDetails?.billingContact?.address?.city || '--' }}
        </div>
      </div>
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.state' | translate }}</div>
        <div class="row-value" id="cardState">{{ transDetails?.stateName || '--' }}</div>
      </div>
      <div class="detail-row indent">
        <div class="row-value">{{ 'paymentDetails.zipCode' | translate }}</div>
        <div class="row-value" id="cardZip">
          {{ transDetails?.billingContact?.address?.postalCode || '--' }}
        </div>
      </div>
    </div>
    <div class="details-card">
      <div class="details-header">
        <h5>{{ 'paymentDetails.transactionTotals' | translate }}</h5>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.subTotal' | translate }}</div>
        <div class="row-value">
          $<span id="transactionSubtotal">{{
            transDetails?.tenderInfo?.amount | customFormatCurrency
          }}</span>
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.technologyFee' | translate }}</div>
        <div class="row-value">
          $<span id="technologyFee">{{
            (transDetails?.tenderInfo?.adjustmentAmount | customFormatCurrency) || 0.0
          }}</span>
        </div>
      </div>
      <hr />
      <div class="detail-row">
        <div class="row-key">{{ 'paymentDetails.shopperTotal' | translate }}</div>
        <div class="row-value">
          $<span id="shopperTotal">{{
            transDetails?.tenderInfo?.captureAmount | customFormatCurrency
          }}</span>
        </div>
      </div>
      <br />
      @if (settlementSection) {
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.settlement' | translate }}</div>
          <div class="row-value"></div>
        </div>
      }
      @if (settlementSection) {
        <span>
          @for (itemData of splitsPaymentDetails; track itemData) {
            <div class="detail-row">
              <div class="row-key">{{ itemData?.virtualAccount.replace('_', ' ') }}</div>
              <div class="row-value">
                $<span id="va1Amount" class="mx-1">{{
                  itemData?.amount | customFormatCurrency
                }}</span>
                $<span id="va1Total">{{ itemData?.subAmt | customFormatCurrency }}</span>
              </div>
            </div>
          }
        </span>
      }
      @if (settlementSection) {
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.processingFees' | translate }}</div>
          <div class="row-value negative-amount">
            $<span id="processingFee">{{ processingFee?.amount | customFormatCurrency }}</span>
          </div>
        </div>
      }
      @if (settlementSection) {
        <hr />
      }
      @if (settlementSection) {
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.total' | translate }}</div>
          <div class="row-value">
            $<span id="transactionTotal">{{ settlementTotal | customFormatCurrency }}</span>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="details-column column-2">
    <!-- If payment was refunded -->
    @if (refundTransactions?.length > 0) {
      <div class="details-card">
        <div class="details-header">
          <h5>{{ 'paymentDetails.refundDetails.header' | translate }}</h5>
          <!-- If multiple refunds -->
          @if (refundTransactions?.length > 1) {
            <h5 class="d-flex align-items-center">
              <!-- hide back arrow if on first page -->
              <span
                class="material-symbols-outlined refund-arrow"
                id="refundBack"
                (click)="prevRefundTransaction()"
                [class.disabled]="currentIndex === 0"
                >&#xe5cb;</span
              >
              {{ currentIndex + 1 }} of {{ refundTransactions.length }}
              <!-- hide next arrow if on last page -->
              <span
                class="material-symbols-outlined refund-arrow"
                id="refundNext"
                (click)="nextRefundTransaction()"
                [class.disabled]="currentIndex === refundTransactions.length - 1"
                >&#xe5cc;</span
              >
            </h5>
          }
        </div>
        <div class="refund-page">
          <div class="detail-row">
            <div class="row-key">
              {{ 'paymentDetails.transactionDetails.transactionID' | translate }}
            </div>
            <div class="row-value">
              <span class="break-line">{{ currentRefundTransaction.transactionId }}</span>
              <span
                class="material-symbols-outlined copy-icon"
                (click)="
                  allyCommonService.copyValueToClipboard(currentRefundTransaction.transactionId)
                "
                tabindex="0"
                (keydown.enter)="
                  allyCommonService.copyValueToClipboard(currentRefundTransaction.transactionId)
                "
                >&#xe14d;</span
              >
            </div>
          </div>
          <div class="detail-row">
            <div class="row-key">{{ 'paymentDetails.refundDetails.amount' | translate }}</div>
            <div class="row-value">
              $<span>{{ currentRefundTransaction.amount | customFormatCurrency }}</span>
            </div>
          </div>
          <div class="detail-row">
            <div class="row-key">{{ 'paymentDetails.refundDetails.reason' | translate }}</div>
            <div class="row-value">
              {{
                currentRefundTransaction?.refundReason +
                  ' - ' +
                  currentRefundTransaction?.refundDetail
              }}
            </div>
          </div>
          <div class="detail-row">
            <div class="row-key">{{ 'paymentDetails.refundDetails.type' | translate }}</div>
            <div class="row-value">{{ currentRefundTransaction.refundType }}</div>
          </div>
          <div class="detail-row">
            <div class="row-key">{{ 'paymentDetails.refundDetails.status' | translate }}</div>
            <div class="row-value">
              <div class="status-button green">
                <div class="status-circle"></div>
                <span class="status-text">
                  {{
                    currentRefundTransaction?.transactionStatus === 'Authorized'
                      ? 'Refund Authorized'
                      : currentRefundTransaction?.transactionStatus
                  }}
                </span>
              </div>
            </div>
          </div>
          <div class="detail-row">
            <div class="row-key">{{ 'paymentDetails.transactionDetails.date' | translate }}</div>
            <div class="row-value">
              {{ currentRefundTransaction.transactionDate | date: 'MMM d,y, h:mm:ss a' }}
            </div>
          </div>
          <div class="detail-row">
            <div class="row-key">
              {{ 'paymentDetails.refundDetails.actionTakenBy' | translate }}
            </div>
            <div class="row-value">{{ currentRefundTransaction.createdBy || '--' }}</div>
          </div>
        </div>
      </div>
    }

    <!-- If payment has chargeback -->
    @if (transDetails?.transactionStatus === 'Chargeback') {
      <div class="details-card">
        <div class="details-header">
          <h5>{{ 'paymentDetails.chargebackDetails' | translate }}</h5>
        </div>

        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.refundDetails.amount' | translate }}</div>
          <div class="row-value">
            $<span>{{ (transDetails?.chargeBackAmount | customFormatCurrency) || '--' }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.reasonCode' | translate }}</div>
          <div class="row-value">{{ transDetails?.chargebackReasonCode || '--' }}</div>
        </div>
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.transactionDetails.date' | translate }}</div>
          <div class="row-value">
            {{
              transDetails?.chargebackDateTime
                ? (transDetails.chargebackDateTime | date: 'MMM d,y, h:mm:ss a')
                : '--'
            }}
          </div>
        </div>
        <div class="detail-row">
          <div class="row-key">{{ 'paymentDetails.errorCode' | translate }}</div>
          <div class="row-value">
            {{ transDetails?.chargebackReason || '--' }}
          </div>
        </div>
      </div>
    }

    <!-- Timeline -->
    <div class="details-card timeline-card">
      <div class="details-header">
        <h5>{{ 'paymentDetails.timeline' | translate }}</h5>
      </div>
      <div class="timeline-holder payment-details-timeline d-flex flex-column w-100">
        @for (item of transactionTimeLineList; track item; let last = $last) {
          <div class="timeline-step my-0">
            <div
              class="timeline-progress-icon transStatus"
              [className]="[item.color]"
              [ngClass]="{ active: last }"
            ></div>
            <div class="d-flex flex-column">
              <label class="timeline-label text-uppercase">{{ item.status }}</label>
              <div class="timeline-details">
                @if (item.displayDateTime) {
                  <span>
                    {{ 'paymentDetails.transactionDetails.date' | translate }}:
                    {{ item.datetime | date: 'MMM d,y, h:mm:ss a' }}
                  </span>
                }
                @if (item.transactionStatus === 'Failed' && item?.operationsType === 'Sale') {
                  <div class="timeline-details">
                    <span> {{ 'paymentDetails.errorCode' | translate }}: {{ errorCode }} </span>
                    <br />
                    <span>
                      {{ 'paymentDetails.errorDetails' | translate }}: {{ errorMessage }}
                    </span>
                  </div>
                }
                @if (item.voidReason && item.transactionStatus === 'Cancelled') {
                  <span style="word-break: break-word">
                    <br />
                    {{ 'paymentDetails.refundDetails.reason' | translate }}: {{ item.voidReason }}
                  </span>
                }
                @if (item.displayAmt) {
                  <span style="word-break: break-word">
                    <br />
                    {{ 'paymentDetails.refundDetails.amount' | translate }}: ${{
                      item?.amount | customFormatCurrency
                    }}
                  </span>
                }
                @if (item.transactionStatus === 'Chargeback') {
                  <span style="word-break: break-word">
                    <br />
                    {{ 'paymentDetails.reasonCode' | translate }}:
                    {{ item?.chargebackReasonCode || '--' }}
                  </span>
                }
              </div>
            </div>
            <div class="line" [hidden]="last"></div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
